import React, { useState } from 'react';
import './Accordion.css';
import { useTranslation } from 'react-i18next';
import delovanjeIdroflog from '../assets/delovanjeIdroflog.png';
import smanjenjeInflamacija from '../assets/smanjenjeInflamacija.png';
import poboljsanjeFilma from '../assets/poboljsanjeFilma.png';
import iop from '../assets/iop.png';
import hydrocortisone from '../assets/hydrocortisone.png';
import idroflog from '../assets/idroflog.png';
import alfaLogo from '../assets/AlfaIntes.svg';

const Bullet = ({ children, highlight }) => (
  <p className={`compound-list__item${highlight ? ' compound-list__item--highlight' : ''}`}>
    <span className="compound-list__dot" aria-hidden="true" />
    <span>{children}</span>
  </p>
);

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`accordion-item${isOpen ? ' is-open' : ''}`}>
      <button
        className="accordion-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        type="button"
      >
        <span className="accordion-header__title">{title}</span>
        <span className="accordion-header__icon" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && <div className="accordion-content">{content}</div>}
    </div>
  );
};

const IdrAccordion = () => {
  const [t] = useTranslation('global');

  return (
    <div className="accordion">
      <AccordionItem
        title={t('idroflog.accordianTitle_1')}
        content={
          <div className="work">
            <img src={delovanjeIdroflog} alt={t('idroflog.accordianopisSlike_1')} />
            <div className="accordionText accordionText--equal">
              <div className="compound-list">
                <Bullet>{t('idroflog.accordianText_levo_b1')}</Bullet>
                <Bullet>{t('idroflog.accordianText_levo_b2')}</Bullet>
                <Bullet>{t('idroflog.accordianText_levo_b3')}</Bullet>
                <Bullet>{t('idroflog.accordianText_levo_b4')}</Bullet>
                <Bullet>{t('idroflog.accordianText_levo_b5')}</Bullet>
              </div>
              <div className="compound-list">
                <Bullet>{t('idroflog.accordianText_desno_b1')}</Bullet>
                <Bullet>{t('idroflog.accordianText_desno_b2')}</Bullet>
                <Bullet>{t('idroflog.accordianText_desno_b3')}</Bullet>
              </div>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('idroflog.accordianTitle_2')}
        content={
          <>
            <div className="benefits-grid">
              <div className="benefits">
                <img src={smanjenjeInflamacija} alt={t('idroflog.accordianopisSlike_1')} />
                <p>{t('idroflog.smanjenjeInflamacija')}</p>
              </div>
              <div className="benefits">
                <img src={poboljsanjeFilma} alt={t('idroflog.accordianopisSlike_2')} />
                <p>{t('idroflog.poboljsanjeFilma')}</p>
              </div>
              <div className="benefits">
                <img src={iop} alt={t('idroflog.accordianopisSlike_3')} />
                <p>{t('idroflog.iop')}</p>
              </div>
              <div className="benefits">
                <img src={hydrocortisone} alt={t('idroflog.accordianopisSlike_4')} />
                <p>{t('idroflog.hydrocortisone')}</p>
              </div>
            </div>
            <div className="accordion-refs">
              <p>{t('idroflog.reference_1')}</p>
              <p>{t('idroflog.reference_2')}</p>
            </div>
          </>
        }
      />
      <AccordionItem
        title={t('idroflog.accordianTitle_3')}
        content={
          <div className="accordionList">
            <p className="lead">{t('idroflog.accordianText_3')}</p>
            <div className="compound-list">
              <Bullet>{t('idroflog.bullet_1')}</Bullet>
              <Bullet>{t('idroflog.bullet_2')}</Bullet>
              <Bullet>{t('idroflog.bullet_3')}</Bullet>
              <Bullet>{t('idroflog.bullet_4')}</Bullet>
              <Bullet>{t('idroflog.bullet_5')}</Bullet>
              <Bullet>{t('idroflog.bullet_6')}</Bullet>
              <Bullet>{t('idroflog.bullet_7')}</Bullet>
              <Bullet>{t('idroflog.bullet_8')}</Bullet>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('idroflog.accordianTitle_4')}
        content={
          <div className="accordionText">
            <div className="accordianlogo">
              <ul>
                <li>
                  <span>{t('idroflog.doziranje_label')}</span>
                  {t('idroflog.doziranje')}
                </li>
                <li>
                  <span>{t('idroflog.pakovanje_label')}</span>
                  {t('idroflog.pakovanje')}
                </li>
                <li>
                  <span>{t('idroflog.sadrzi')}</span>
                </li>
                <li>
                  <span>{t('idroflog.kompatibilnost')}</span>
                </li>
                <li>
                  <span>{t('idroflog.proizvodjac_label')}</span>
                  {t('idroflog.proizvodjac')}
                </li>
              </ul>
              <img src={alfaLogo} alt={t('idroflog.accordianopisSlike_1')} />
            </div>
            <div className="proizvod">
              <img src={idroflog} alt={t('idroflog.accordianopisSlike_1')} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default IdrAccordion;
